/**
 * Created by Bart Decorte
 * Date: 2019-08-26
 * Time: 19:13
 */
const EventEmitter = require('events');
import Matrix from '../../../matrix/Matrix';
import BlockElementDrag from '../../../utils/BlockElementDrag';

class EntriesEditMatrix extends Matrix(BlockElementDrag(EventEmitter)) {
  constructor(params) {
    super(params);
  }
}

export default EntriesEditMatrix;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Entries/_partials/EntriesEditMatrix.js